import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'advisorProfile'
})
export class AdvisorProfilePipe implements PipeTransform {

    transform(name: string) {
        if(name) {
           return name.split(/\s+/)[0].charAt(0).toUpperCase() + name.split(/\s+/)[1].charAt(0).toUpperCase();
        }
    }

}